import type { SVGProps } from 'react';
const DawnFlagNP = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M0 1.9C0 .85.85 0 1.9 0c.127 0 .251.038.356.11l8.821 5.987c1.087.737.565 2.436-.749 2.436H6.286l5.767 5.138c.914.815.338 2.329-.887 2.329H2a2 2 0 0 1-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-NP_svg__a"
      width={13}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M0 1.9C0 .85.85 0 1.9 0c.127 0 .251.038.356.11l8.821 5.987c1.087.737.565 2.436-.749 2.436H6.286l5.767 5.138c.914.815.338 2.329-.887 2.329H2a2 2 0 0 1-2-2z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#dawn-flag-NP_svg__a)">
      <path
        fill="#EE1B44"
        stroke="#0543A8"
        strokeLinejoin="round"
        strokeWidth={1.333}
        d="M11.166 15.333H.666V.667H1.89l8.813 5.981c.543.37.282 1.219-.375 1.219H6.286a.667.667 0 0 0-.444 1.164l5.767 5.138a.667.667 0 0 1-.443 1.164Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M5.383 6.24q.455-.127.826-.34a2.1 2.1 0 0 1-2.02 1.567A2.1 2.1 0 0 1 2.17 5.9c.247.14.526.256.829.34l.407-.374-.666-.613.896.047-.046-.913.602.679.601-.679-.046.913.897-.047-.666.613zM3.39 13.705l.802-.904.802.904-.061-1.216 1.195.062-.888-.817.888-.816-1.195.062.06-1.217-.801.905-.802-.905.061 1.217-1.195-.062.888.816-.888.817 1.195-.062z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagNP;
